(function () {
  if (window.__vualinaStorefrontReady) return;
  window.__vualinaStorefrontReady = true;

  function reveal() {
    var nodes = document.querySelectorAll("[data-vualina-reveal]");
    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) {
        node.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function setupReviewSliders() {
    var sliders = document.querySelectorAll("[data-vualina-slider]");
    sliders.forEach(function (slider) {
      if (slider.dataset.ready === "true") return;
      slider.dataset.ready = "true";

      var root = slider.closest(".vualina-reviews");
      var prev = root && root.querySelector("[data-vualina-prev]");
      var next = root && root.querySelector("[data-vualina-next]");

      function step() {
        var card = slider.querySelector(".vualina-review-card");
        return card ? card.getBoundingClientRect().width + 18 : 320;
      }

      if (prev) {
        prev.addEventListener("click", function () {
          slider.scrollBy({ left: -step(), behavior: "smooth" });
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          slider.scrollBy({ left: step(), behavior: "smooth" });
        });
      }

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      slider.addEventListener("mousedown", function (event) {
        isDown = true;
        slider.classList.add("is-dragging");
        startX = event.pageX;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener("mouseleave", function () {
        isDown = false;
        slider.classList.remove("is-dragging");
      });

      slider.addEventListener("mouseup", function () {
        isDown = false;
        slider.classList.remove("is-dragging");
      });

      slider.addEventListener("mousemove", function (event) {
        if (!isDown) return;
        event.preventDefault();
        var walk = (event.pageX - startX) * 1.1;
        slider.scrollLeft = scrollLeft - walk;
      });
    });
  }

  var productMoneyFormatter = new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  function formatProductMoney(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll(
      ".template-product [data-vualina-money-cents]"
    );

    nodes.forEach(function (node) {
      var cents = Number(node.getAttribute("data-vualina-money-cents"));
      if (!Number.isFinite(cents)) return;
      node.textContent = productMoneyFormatter.format(cents / 100) + "\u00a0TL";
    });
  }

  function orderProductSizes(root) {
    var scope = root || document;
    var sizeOrder = {
      XS: 10,
      S: 20,
      "S-M": 25,
      M: 30,
      L: 40,
      "L-XL": 45,
      XL: 50,
      "2XL": 60,
      "2XL-3XL": 65,
      "3XL": 70,
      "3XL-4XL": 75,
      "4XL": 80,
    };

    scope
      .querySelectorAll(".template-product .variant-option--buttons")
      .forEach(function (fieldset) {
        var legend = fieldset.querySelector("legend");
        var legendText = legend ? legend.textContent.trim().toLocaleLowerCase("tr-TR") : "";
        if (legendText.indexOf("beden") === -1 && legendText.indexOf("size") === -1) return;

        fieldset.querySelectorAll(".variant-option__button-label").forEach(function (label) {
          var input = label.querySelector("input");
          if (!input) return;
          var key = input.value
            .trim()
            .toLocaleUpperCase("tr-TR")
            .replace(/\s+/g, "")
            .replace(/–/g, "-");
          if (sizeOrder[key]) label.style.order = String(sizeOrder[key]);
        });
      });
  }

  function init() {
    reveal();
    setupReviewSliders();
    formatProductMoney();
    orderProductSizes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("variant:update", function () {
    requestAnimationFrame(function () {
      formatProductMoney();
      orderProductSizes();
    });
  });
})();

// Track successful Horizon cart additions through the existing Klaviyo SDK.
(function () {
  if (window.__vualinaCartTracking) return;
  window.__vualinaCartTracking = true;

  // Load Shopify's permission-checking API without changing visitor consent.
  if (window.Shopify && !window.Shopify.customerPrivacy &&
      typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }

  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    var cart = detail.resource;
    var variantId = Number(detail.sourceId);
    var quantity = Number(data.itemCount);
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    // Horizon also uses cart:update for edits and failed additions.
    if (data.source !== 'product-form-component' || data.didError ||
        !Number.isSafeInteger(variantId) || variantId <= 0 ||
        !Number.isSafeInteger(quantity) || quantity <= 0 ||
        !cart || !Array.isArray(cart.items)) return;

    // Respect the merchant's regional consent policy; never grant consent here.
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        typeof privacy.marketingAllowed !== 'function' ||
        !privacy.analyticsProcessingAllowed() || !privacy.marketingAllowed()) return;

    var added = cart.items.find(function (item) {
      return Number(item.variant_id || item.id) === variantId;
    });
    if (!added) return;

    var image = added.featured_image && added.featured_image.url || added.image || '';
    var payload = {
      '$value': cart.total_price / 100,
      '$currency': cart.currency,
      'Product Name': added.product_title || added.title,
      ProductID: added.product_id,
      VariantID: variantId,
      'Variant Name': added.variant_title,
      Quantity: quantity,
      Price: (typeof added.final_price === 'number' ? added.final_price : added.price) / 100,
      ImageURL: image ? new URL(image, window.location.origin).href : '',
      URL: new URL(added.url, window.location.origin).href,
      ItemNames: cart.items.map(function (item) { return item.product_title || item.title; }),
      TrackingSource: 'vualina-horizon-cart-v1'
    };
    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Added to Cart', payload]);
  });
})();
